import { createSlice } from "@reduxjs/toolkit";

const initialExperimentState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  entities2: [],
  lastError: null,
  filteredEntities: "",
  experimentFetchedById: "",
  totalexperimentFetched: 0,
  totalRequestedCount: 0,
  page:1,
  size:10,
  reqPage:1,
  reqSize:10
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ExperimentManagementAdminSlice = createSlice({
  name: "dl-Experiment",
  initialState: initialExperimentState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    experimentFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = action.payload.items;
      state.totalexperimentFetched = action.payload.total;
      state.page=action.payload.page;
      state.size=action.payload.size;
      state.totalCount = action.payload.length;
    },
    experimentRequestedFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;

      state.entities2 = action.payload.items;
      state.totalCount = action.payload.length;
      state.reqPage=action.payload.page;
      state.reqSize=action.payload.size;
      state.totalRequestedCount = action.payload.total;
    },

    experimentFetchedById: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.experimentFetchedById = action.payload;
    },

    experimentCreated: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.entities.push(action.payload);
      state.error = null;
    },

    experimentUpdated: (state, action) => {
      let data = action.payload;
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entities = state.entities.map(entity => {
        if (entity.id === data.id) {
          return data;
        }
        return entity;
      });
    },

    clearExperimentById: (state, action) => {
      state.experimentFetchedById = "";
    }
  }
});
